import { CLIENT_RUNTIME_CONFIG_KEYS } from '../../server/clientRuntimeConfigKeys.mjs';

const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

// In development, window.__RUNTIME_CONFIG__ is not injected, so we fall back to
// process.env.REACT_APP_* values baked in by Vite's define from .env.local.
//
// In production, window.__RUNTIME_CONFIG__ is injected by the Node.js server at
// runtime. We do NOT fall back to process.env.REACT_APP_* because those vars may
// not have been set at build time, which would leave a live `process` reference in
// the bundle that can throw ReferenceError in the browser.
const isDev = process.env.NODE_ENV === 'development';

const DEFAULT_VALUES = {
  REACT_APP_API_URL: '/'
};

const config = CLIENT_RUNTIME_CONFIG_KEYS.reduce((acc, key) => {
  acc[key] = runtimeConfig[key] || (isDev && process.env[key]) || DEFAULT_VALUES[key] || undefined;
  return acc;
}, {});

export default Object.freeze(config);
